<template>
  <div class="audience-preview p-4 border border-blue border-solid rounded-2xl w-80 relative">

    <template v-if="isNameEditable">
      <label class="ml-3 ">name</label>
      <input :value="name"
             class="sb-input mt-1 border-can-error font-primary text-xl"
             placeholder="name your audience"
             type="text"
             @input="(e) => this.$emit('update:name', e.target.value)"
      />
    </template>
    <template v-else>
      <div class="h-7 mb-3">
        <div class="audience-name absolute left-0 w-full px-4 text-xl text-center z-10">
          <div class="bg-white truncate">{{ name }}</div>
          <div class="gradient h-4 hidden" />
        </div>
      </div>
    </template>
    <div class="circle">
      <div v-if="isKpiDataLoading">
        <LoadingIcon />
      </div>
      <div v-else class="flex flex-col text-center">
        <span class="text-4xl" :class="{'text-red': isKpiDataOutdated}">{{ formattedMembersCount }}</span>
        <span class="text-lg">{{ membersCount | pluralize('member') }}</span>
        <TrendArrow v-if="percentProgress != null" :value="Math.round(percentProgress)" :text-after="`${Math.round(percentProgress)}%`" />
      </div>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { commafyNumber } from '../../utilities/index';
import { LoadingIcon } from '@springbig/sb-components';
import TrendArrow from "./TrendArrow";

export default {
  name: 'AudiencePreview',
  components: { LoadingIcon, TrendArrow },
  computed: {
    formattedMembersCount() {
      return commafyNumber(this.membersCount);
    }
  },
  props: {
    membersCount: {type: Number, default: 0},
    name: {type: String, default: null},
    isNameEditable: {type: Boolean, default: false},
    isKpiDataOutdated: {type: Boolean, default: false},
    isKpiDataLoading: {type: Boolean, default: false},
    percentProgress: Number
  }
};
</script>

<style lang="scss" scoped>
.audience-name {
  &:hover {
    >div {
      white-space: break-spaces;
    }
    >div.gradient {
      display: block;
      background: linear-gradient(180deg, #ffffff 20%, #ffffff00 80%);
    }
  }
}
.circle {
  $border: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 230px;
  height: 230px;
  margin: auto;
  max-width: 22em;
  position: relative;
  box-sizing: border-box;
  background: #fff;
  background-clip: padding-box;
  border: solid $border transparent;
  border-radius: 1000px;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    margin: -$border;
    border-radius: inherit;
    background: linear-gradient(45deg, #6044f8, #128ff9);
  }
}
.sb-loading-icon {
  opacity: .5;
}
</style>
